export const shouldResolvePaymentAccountParam = (
  accountParam: string | null,
  resolvedAccountParam: string | null
): accountParam is string => Boolean(accountParam) && accountParam !== resolvedAccountParam;
